import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { CTAPair } from "../components/CTA";

const NotFound = () => (
  <main data-testid="not-found-page" className="bg-paper">
    <SEO title="Page Not Found | Aledo Welding" description="That page doesn't exist — but your repair still needs fixing. Text a photo for a fast quote." />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-24 md:py-32">
      <p className="font-display font-black text-7xl text-ink/10" data-testid="not-found-code">404</p>
      <h1 className="font-display font-black tracking-tight text-4xl sm:text-5xl mt-4" data-testid="not-found-heading">
        That page isn't here. Your repair still is.
      </h1>
      <p className="mt-4 max-w-xl text-smoke text-lg">
        Whatever brought you here, the fastest next step is the same: text us two photos of what's broken, or head back to the <Link to="/" data-testid="not-found-home-link" className="text-rust font-semibold hover:text-rust-dark">homepage</Link>.
      </p>
      <div className="mt-8"><CTAPair testidPrefix="not-found-cta" /></div>
    </div>
  </main>
);

export default NotFound;
